module.exports = __webpack_public_path__ + "media/SuiteApp/assets/svg/img/signme light-vector-c0a67381ff01b1f7af356391b5e946c4.svg";